const animateHomeHeader = () => {
    // this is the first element in hero, if this is present the header has to animate
    const heroTrigger = document.querySelector(".content-step.second-content")
    if(!heroTrigger) return
    
    // updates header text color
    gsap.fromTo("header.custom-header", {
        "--color": "#FFFFFF"
    }, {
        scrollTrigger: {
            trigger: heroTrigger,
            start: "top bottom",
            end: "top top",
            scrub: true
        },
        "--color": "#000000"
    })
}

animateHomeHeader()
document.addEventListener("shopify:section:load", animateHomeHeader);